import React, { Component, Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Index from '../pages/Index';
import Contact from '../pages/Contact';
import DealingWithAgents from '../pages/DealingWithAgents';
import StepsToBuy from '../pages/StepsToBuy';
import WaysToPurchase from '../pages/WaysToPurchase';
import Auction from '../pages/ways_to_purchase/Auction';
import Tender from '../pages/ways_to_purchase/Tender';
import DeadlineSale from '../pages/ways_to_purchase/DeadlineSale';
import AdvertisedPrice from '../pages/ways_to_purchase/AdvertisedPrice';
import Negotiation from '../pages/ways_to_purchase/Negotiation';
import PuttingInAnOffer from '../pages/PuttingInAnOffer';
import Walkthrough from '../pages/Walkthrough';
import HowMuchCanYouGet from '../pages/HowMuchCanYouGet';
import Thankyou from '../pages/Thankyou';
import Glossary from '../pages/Glossary';
import Valuation from '../pages/Valuation';
import OurStory from '../pages/OurStory';
import Lawyers from '../pages/Lawyers';
import AllArticles from '../pages/AllArticles';

import FourOhFour from '../pages/FourOhFour';

import { IframeCustom } from '../components/Iframe';

export const UNLISTED_ROUTES = [
  { url: '/articles/:id', name: '', component: IframeCustom },
  { url: '/thankyou', name: '', component: Thankyou },
  { url: '/contact', name: 'Contact', component: Contact },
  { url: '/ways-to-purchase/auctions', name: 'Auction', component: Auction },
  { url: '/ways-to-purchase/auction', name: 'Auction', component: Auction },
  { url: '/ways-to-purchase/tender', name: 'Tender', component: Tender },
  { url: '/ways-to-purchase/negotiation', name: 'Negotiation', component: Negotiation },
  { url: '/ways-to-purchase/deadline-sale', name: 'DeadlineSale', component: DeadlineSale },
  { url: '/ways-to-purchase/advertised-price', name: 'Advertised Price', component: AdvertisedPrice },
];

export const ROUTES = [
  { url: '/all-articles', name: 'All Articles', component: AllArticles },
  { url: '/walkthrough', name: 'Walkthrough', component: Walkthrough },
  { url: '/our-story', name: 'Our Story', component: OurStory },
  { url: '/how-much-can-you-get', name: 'How Much Can You Get', component: HowMuchCanYouGet },
  { url: '/ways-to-purchase', name: 'Ways To Purchase', component: WaysToPurchase },
  { url: '/dealing-with-agents', name: 'Dealing With Agents', component: DealingWithAgents },
  { url: '/steps-to-buy', name: 'Steps To Buy a House', component: StepsToBuy },
  { url: '/putting-in-an-offer', name: 'Putting In An Offer', component: PuttingInAnOffer },
  { url: '/valuation', name: 'Valuations', component: Valuation },
  { url: '/lawyers', name: 'Lawyers', component: Lawyers },
  { url: '/glossary', name: 'Glossary', component: Glossary },
];
export default class Router extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Index} />
          {UNLISTED_ROUTES.map(r => (
            <Route path={r.url} exact component={r.component} />
          ))}
          {ROUTES.map(r => (
            <Route path={r.url} exact component={r.component} />
          ))}
          <Route component={FourOhFour} />
        </Switch>
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Router.jsx